import {
  Box,
  Button,
  Card,
  Dialog,
  DialogActions, DialogContent, Fade, FormControl, FormControlLabel,
  FormHelperText, FormLabel, Grid, IconButton, InputLabel, MenuItem,
  Radio, RadioGroup, Select, Stack, TextField, Typography
} from '@mui/material';
import Close from 'mdi-material-ui/Close';
import { forwardRef, useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { apiService } from '../../api/axiosClient';

const Transition = forwardRef((props, ref) => <Fade ref={ref} {...props} />)

const RegisterCategory = (props) => {
  const { show, setShow, reload, setReload} = props;
  const [category1, setCategory1] = useState([]);
  const [category2, setCategory2] = useState([]);
  const [target, setTarget] = useState(1);
  const [formID, setFormID] = useState('form1');

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset
  } = useForm();
  const {
    control: control2,
    formState: { errors: errors2 },
    handleSubmit: handleSubmit2,
    reset: reset2
  } = useForm();
  const {
    control: control3,
    formState: { errors: errors3 },
    handleSubmit: handleSubmit3,
    reset: reset3
  } = useForm();

  const loadCategory1 = () => {
    const fetchData = async () => {
      try {
        const _response = await apiService.get('/category/level/1');
        const _payload = _response.data;

        setCategory1(_payload.list);
      } catch (e) {
        console.error(e);
      }
    }

    fetchData();
  }

  const loadCategory2 = (level) => {
    const fetchData = async () => {
      try {
        const _response = await apiService.get('/category/level/2', { params: { q: level } })
        const _payload = _response.data;
        setCategory2(_payload.list);
      } catch (e) {
        console.error(e);
      }
    }

    fetchData();
  }

  useEffect(() => {
    if(!show) {
      setCategory2([]);
      setTarget(1);
    }
  }, [show]);

  useEffect(loadCategory1, [reload])

  useEffect(() => {
    reset({
      name1: ""
    });
    reset2({
      m2_category1: "",
      name2: "",
    });
    reset3({
      m3_category1: "",
      m3_category2: "",
      name3: "",
    });

    const id = ["form1", "form2", "form3"].find((_, index) => {
      return (index + 1) == target
    })
    setFormID(id);
  }, [target])

  const handleRadioChange = e => {
    setTarget(e.target.value);
  }

  const onPost = async (params) => {
    try {
      await apiService.post('/category', params)
      toast.success('등록 되었습니다.');
      setReload(reload + 1);
    } catch (error) {
      console.error(error);
    } finally {
      setShow(false);
    }
  }

  const onSubmit1 = async (data, e) => {
    onPost({
      "level1": data.name1,
      "level2": "",
      "level3": "",
      "ca_order": 0,
      "ca_use": true,
      "level": "l1"
    })
  }

  const onSubmit2 = async (data, e) => {
    onPost({
      "level1": data.m2_category1,
      "level2": data.name2,
      "level3": "",
      "ca_order": 0,
      "ca_use": true,
      "level": "l2"
    })
  }

  const onSubmit3 = async (data, e) => {
    onPost({
      "level1": data.m3_category1,
      "level2": data.m3_category2,
      "level3": data.name3,
      "ca_order": 0,
      "ca_use": true,
      "level": "l3"
    })
  }

  return (
    <Card>
      <Dialog
        fullWidth
        open={show}
        maxWidth='md'
        scroll='body'
        onClose={() => setShow(false)}
        TransitionComponent={Transition}
      >
        <DialogContent sx={{ pb: 3, px: { xs: 8, sm: 15 }, pt: { xs: 4, sm: 8 }, position: 'relative' }}>
          <IconButton
            size='small'
            onClick={() => setShow(false)}
            sx={{ position: 'absolute', right: '1rem', top: '1rem' }}
          >
            <Close />
          </IconButton>
          <Box sx={{ mb: 4, textAlign: 'center' }}>
            <Typography variant='h5' sx={{ mb: 3, lineHeight: '2rem' }}>
              카테고리 등록
            </Typography>
          </Box>

          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Box sx={{mb: 4}}>
                <FormControl fullWidth >
                  <FormLabel id="category-group-label">등록 카테고리</FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="category-group-label"
                    name="category-radio-group"
                    onChange={handleRadioChange}
                    defaultValue="1"
                  >
                    <FormControlLabel value="1" control={<Radio />} label="1차 카테고리" />
                    <FormControlLabel value="2" control={<Radio />} label="2차 카테고리" />
                    <FormControlLabel value="3" control={<Radio />} label="3차 카테고리" />
                  </RadioGroup>
                </FormControl>
              </Box>

              <Grid item xs={12} hidden={target == 1 ? false: true}>
                <Grid>
                  <form key={1} onSubmit={handleSubmit(onSubmit1)} id="form1">
                  <Stack spacing={4} sx={{py: 4 }}>
                    <FormControl>
                      <Controller
                        name='name1'
                        control={control}
                        rules={{ required: true }}
                        defaultValue=""
                        render={({ field: { value, onChange } }) => (
                          <TextField
                            value={value}
                            label='1차 카테고리'
                            variant="standard"
                            id='name1'
                            onChange={onChange}
                            placeholder='이름을 입력해주세요'
                            error={Boolean(errors.name1)}
                            aria-describedby='validation-async-name1'
                          />
                        )}
                      />
                      {errors.name1 && (
                        <FormHelperText sx={{ color: 'error.main' }} id='validation-async-name1'>
                          필수
                        </FormHelperText>
                      )}
                    </FormControl>
                  </Stack>
                  </form>
                </Grid>                
              </Grid>

              <Grid item xs={12} hidden={target == 2 ? false: true}>
                <Grid>
                  <form key={2} onSubmit={handleSubmit2(onSubmit2)} id="form2">
                    <Stack spacing={4} sx={{py: 4 }}>
                      <FormControl>
                        <InputLabel id='m2_category1_title'>1차 카테고리</InputLabel>
                        <Controller
                          name='m2_category1'
                          control={control2}
                          rules={{ required: true }}
                          render={({ field: { value, onChange } }) => (
                            <Select
                              label='1차 카테고리'
                              value={value}
                              onChange={onChange}
                              labelId='m2_category1_title'
                              error={Boolean(errors2.m2_category1)}
                            >
                              {category1 !== undefined &&
                                category1.map(item => (
                                  <MenuItem key={item} value={item}>
                                    {item}
                                  </MenuItem>
                                ))}
                            </Select>
                          )}
                        />
                        {errors2.m2_category1 && (
                          <FormHelperText sx={{ color: 'error.main' }} id='validation-async-m2_category1'>
                            필수
                          </FormHelperText>
                        )}
                      </FormControl>
                      <FormControl>
                        <Controller
                          name='name2'
                          control={control2}
                          rules={{ required: true }}
                          defaultValue=""
                          render={({ field: { value, onChange } }) => (
                            <TextField
                              value={value}
                              label='2차 카테고리'
                              variant="standard"
                              id='name2'
                              onChange={onChange}
                              placeholder='이름을 입력해주세요'
                              error={Boolean(errors2.name2)}
                              aria-describedby='validation-async-name2'
                            />
                          )}
                        />
                        {errors2.name2 && (
                          <FormHelperText sx={{ color: 'error.main' }} id='validation-async-name2'>
                            필수
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Stack>
                  </form>
                </Grid>
              </Grid>

              <Grid item xs={12} hidden={target == 3 ? false: true}>
                <Grid>
                  <form key={3} onSubmit={handleSubmit3(onSubmit3)} id="form3">
                    <Stack spacing={4} sx={{py: 4 }}>
                      <FormControl>
                        <InputLabel id='m3_category1_title'>1차 카테고리</InputLabel>
                        <Controller
                          name='m3_category1'
                          control={control3}
                          rules={{ required: true }}
                          render={({ field: { value, onChange } }) => (
                            <Select
                              label='1차 카테고리'
                              value={value}
                              onChange={(e) => {
                                onChange(e)
                                loadCategory2(e.target.value)
                              }}
                              labelId='m3_category1_title'
                              error={Boolean(errors3.m3_category1)}
                            >
                              {category1 !== undefined &&
                                category1.map(item => (
                                  <MenuItem key={item} value={item}>
                                    {item}
                                  </MenuItem>
                                ))}
                            </Select>
                          )}
                        />
                        {errors3.m3_category1 && (
                          <FormHelperText sx={{ color: 'error.main' }} id='validation-async-m3_category1'>
                            필수
                          </FormHelperText>
                        )}
                      </FormControl>
                      <FormControl>
                        <InputLabel id='m3_category2_title'>2차 카테고리</InputLabel>
                        <Controller
                          name='m3_category2'
                          control={control3}
                          rules={{ required: true }}
                          render={({ field: { value, onChange } }) => (
                            <Select
                              label='2차 카테고리'
                              value={value}
                              onChange={onChange}
                              labelId='m3_category2_title'
                              error={Boolean(errors3.m3_category2)}
                            >
                              {category2 !== undefined &&
                                category2.map(item => (
                                  <MenuItem key={item} value={item}>
                                    {item}
                                  </MenuItem>
                                ))}
                            </Select>
                          )}
                        />
                        {errors3.m3_category2 && (
                          <FormHelperText sx={{ color: 'error.main' }} id='validation-async-m3_category2'>
                            필수
                          </FormHelperText>
                        )}
                      </FormControl>
                      <FormControl>
                        <Controller
                          name='name3'
                          control={control3}
                          rules={{ required: true }}
                          defaultValue=""
                          render={({ field: { value, onChange } }) => (
                            <TextField
                              value={value}
                              label='3차 카테고리'
                              variant="standard"
                              id='name3'
                              onChange={onChange}
                              placeholder='이름을 입력해주세요'
                              error={Boolean(errors3.name3)}
                              aria-describedby='validation-async-name3'
                            />
                          )}
                        />
                        {errors3.name3 && (
                          <FormHelperText sx={{ color: 'error.main' }} id='validation-async-name3'>
                            필수
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Stack>
                  </form>
                </Grid>
              </Grid>

            </Grid>
          </Grid>
          
        </DialogContent>  

        <DialogActions sx={{ pb: { xs: 4, sm: 8 }, justifyContent: 'center' }}>
            <Button type="submit" form={formID} variant='contained'> 등록 </Button>
            <Button variant='outlined' color='secondary' onClick={() => setShow(false)}> 취소 </Button>
        </DialogActions>
      </Dialog>
    </Card>
  )
}

export default RegisterCategory